<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import recurringInvoiceStore from "./store.js";

export default {
  name: "subscription-home",
  mixins: [RegisterStoreModule],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    ...mapGetters("subscription", ["SubscriptionDetails"]),
  },
  methods: {
    ...mapActions("subscription", ["ResetSubscription"]),
    newInvoice() {
      if (this.SubscriptionDetails.length !== 0) {
        this.$swal({
          title: "Are you sure?",
          text: "There is an running subscription you want to clear it",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.ResetSubscription();
            if (this.CustomerId) {
              this.$router.push({
                path: `/subscription/create?CustomerId=${this.CustomerId}`,
              });
            } else {
              this.$router.push({ path: `/subscription/create` });
            }
          }
        });
      } else {
        if (this.CustomerId) {
          this.$router.push({
            path: `/subscription/create?CustomerId=${this.CustomerId}`,
          });
        } else {
          this.$router.push({ path: `/subscription/create` });
        }
      }
    },
  },
  created() {
    this.registerStoreModule("subscription", recurringInvoiceStore);
  },
};
</script>
